import React from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { slide as Menu } from "react-burger-menu"
import PropTypes from "prop-types"
import { document } from "browser-monads"

const MenuStyle = styled(Menu)``

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  padding: 20px;
  width: 100%;
`

const MenuWrapper = styled.div`
  position: fixed;
  z-index: 705;
  top: 0;
  width: 100%;
`

const BackButton = styled.div`
  border-radius: 100%;
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(31, 31, 35, 0.1);
  margin-right: 16px;
`

const MenuHolder = styled.div`
  max-height: calc(100vh - 144px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
`

const IconButton = styled.button`
  background-color: "#ddd";
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  svg {
    color: white;
  }
`

const CloseButton = styled(IconButton)`
  background-color: #eaeaea;

  svg {
    color: #4a4a4a;
  }
`

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #4a4a4a;
  padding-left: 8px !important;

  &::placeholder {
    color: #7a7a7a;
  }
`

const SearchMenuSlider = ({
  children,
  isOpen,
  setIsOpen,
  onChange,
  onFocus,
  placeholder,
}) => {
  const [query, setQuery] = React.useState("")

  const MobileMenuStyles = {
    bmBurgerButton: {
      display: "none",
    },
    bmCrossButton: {
      display: "none",
    },

    bmMenuWrap: {
      paddingTop: "0px",
      position: "fixed",
      height: "100%",
      width: "100%",
      maxWidth: "425px",
    },
    bmMenu: {
      background: "#fff",
      // padding: "42px 12px 8px 24px",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
    bmMorphShape: {
      fill: "#373a47",
    },
    bmItemList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    bmItem: {
      display: "flex",
    },
    bmOverlay: {
      background: "rgba(0, 0, 0, 0.3)",
    },
  }

  const handleClear = () => {
    onChange({
      target: {
        value: "",
      },
    })
    setQuery({
      target: {
        value: "",
      },
    })
  }

  const sliderContent = (
    <MenuWrapper>
      <MenuStyle
        right
        styles={MobileMenuStyles}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <SearchBarContainer>
          <BackButton onClick={() => setIsOpen(false)}>
            <LeftArrow />
          </BackButton>
          <SearchInput
            type="text"
            placeholder={placeholder}
            value={query?.target?.value}
            onChange={e => {
              onChange(e)
              setQuery(e)
            }}
            onFocus={onFocus}
          />

          {query?.target?.value && (
            <CloseButton onClick={handleClear}>
              <Exit />
            </CloseButton>
          )}
        </SearchBarContainer>
        <MenuHolder>{children}</MenuHolder>
      </MenuStyle>
    </MenuWrapper>
  )

  // Use ReactDOM.createPortal to render into the ___gatsby element
  const portalTarget =
    typeof window !== "undefined" && document.getElementById("___gatsby")
  return portalTarget
    ? ReactDOM.createPortal(sliderContent, portalTarget)
    : null
}

export default SearchMenuSlider

SearchMenuSlider.propTypes = {
  children: PropTypes.any,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
}

const Exit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M17.6776 16.499L15.3206 14.142L17.6776 11.785C17.8339 11.6287 17.9217 11.4168 17.9217 11.1957C17.9217 10.9747 17.8339 10.7628 17.6776 10.6065C17.5213 10.4502 17.3094 10.3624 17.0884 10.3624C16.8674 10.3624 16.6554 10.4502 16.4991 10.6065L14.1421 12.9635L11.7851 10.6065C11.6288 10.4502 11.4168 10.3624 11.1958 10.3624C10.9748 10.3624 10.7628 10.4502 10.6066 10.6065C10.4503 10.7628 10.3625 10.9747 10.3625 11.1957C10.3625 11.4168 10.4503 11.6287 10.6066 11.785L12.9636 14.142L10.6066 16.499C10.4503 16.6553 10.3625 16.8673 10.3625 17.0883C10.3625 17.3093 10.4503 17.5213 10.6066 17.6776C10.7628 17.8338 10.9748 17.9216 11.1958 17.9216C11.4168 17.9216 11.6288 17.8338 11.7851 17.6776L14.1421 15.3205L16.4991 17.6776C16.6554 17.8338 16.8674 17.9216 17.0884 17.9216C17.3094 17.9216 17.5213 17.8338 17.6776 17.6776C17.8339 17.5213 17.9217 17.3093 17.9217 17.0883C17.9217 16.8673 17.8339 16.6553 17.6776 16.499Z"
        fill="#1F1F23"
      />
    </svg>
  )
}

const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 11H9L12.29 7.71C12.3837 7.61703 12.4581 7.50643 12.5089 7.38457C12.5597 7.26272 12.5858 7.13201 12.5858 7C12.5858 6.86799 12.5597 6.73728 12.5089 6.61542C12.4581 6.49356 12.3837 6.38296 12.29 6.29C12.1026 6.10375 11.8492 5.99921 11.585 5.99921C11.3208 5.99921 11.0674 6.10375 10.88 6.29L6.59 10.59C6.21441 10.9633 6.00223 11.4704 6 12V12C6.00487 12.5261 6.21684 13.0291 6.59 13.4L10.88 17.7C10.9732 17.7926 11.0838 17.8659 11.2054 17.9157C11.3269 17.9656 11.4571 17.991 11.5885 17.9905C11.7199 17.9901 11.8499 17.9637 11.9712 17.913C12.0924 17.8623 12.2024 17.7882 12.295 17.695C12.3876 17.6017 12.4609 17.4912 12.5107 17.3696C12.5606 17.248 12.586 17.1178 12.5856 16.9864C12.5851 16.8551 12.5588 16.725 12.508 16.6038C12.4573 16.4826 12.3832 16.3726 12.29 16.28L9 13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1053 19.2652 11 19 11Z"
        fill="#1F1F23"
      />
    </svg>
  )
}
